import type { BadgeProps } from "@/components/ui/badge";
import type { IntegrationStatus } from "@/types";

export type SortMode = "updated" | "alpha-asc" | "alpha-desc";

export interface KanbanStage {
	id: string;
	label: string;
	statuses: IntegrationStatus[];
	colorClass: string;
	badgeVariant: BadgeProps["variant"];
	/** When true, column is hidden from Kanban view (status still exists elsewhere) */
	hiddenInKanban?: boolean;
}

export const KANBAN_STAGES: KanbanStage[] = [
	{
		id: "kyb-contracting",
		label: "KYB & Contracting",
		statuses: ["New - Pre-Integration"],
		colorClass: "bg-(--color-neutral-400)",
		badgeVariant: "secondary",
	},
	{
		id: "technical-integration",
		label: "Technical Integration",
		statuses: ["Integrating"],
		colorClass: "bg-(--color-info-500)",
		badgeVariant: "info",
	},
	{
		id: "testing",
		label: "Testing",
		statuses: ["Testing"],
		colorClass: "bg-(--color-warning-500)",
		badgeVariant: "warning",
	},
	{
		id: "ready-to-go-live",
		label: "Ready to Go Live",
		statuses: ["Ready to Go Live"],
		colorClass: "bg-(--color-info-500)",
		badgeVariant: "info",
		hiddenInKanban: true,
	},
	{
		id: "live",
		label: "Live",
		statuses: ["Live"],
		colorClass: "bg-(--color-success-500)",
		badgeVariant: "success",
	},
	{
		id: "unresponsive",
		label: "Unresponsive",
		statuses: ["On-Hold", "Abandoned"],
		colorClass: "bg-(--color-error-500)",
		badgeVariant: "destructive",
	},
];

export function getIntegrationColorClass(status: IntegrationStatus): string {
	const stage = KANBAN_STAGES.find((s) => s.statuses.includes(status));
	return stage?.colorClass ?? "bg-(--color-neutral-400)";
}
